import { ActionIcon, Indicator, Popover, Text, createStyles, Checkbox, Group, Anchor, Divider } from '@mantine/core';
import { IconAdjustmentsHorizontal } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';

// Custom styles
const useStyles = createStyles((theme) => ({
	label: {
		fontSize: 14,
		lineHeight: '18px',
		fontWeight: 'bold',
		padding: 12
	},
	optionLabel: {
		textTransform: 'capitalize',
		fontSize: 14,
		lineHeight: '18px',
	},
	optionRow: {
		padding: '8px 12px',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: 'rgba(230, 210, 246, 0.5)'
		}
	},
	isSelected: {
		backgroundColor: 'rgba(230, 210, 246, 0.5)'
	}
}));

// Option to select
const Option = ({ text, action, active }) => {

	// State and hooks
	const { classes, cx } = useStyles();

	return (
		<Group
			className={cx(classes.optionRow, { [classes.isSelected]: active })}
			position="apart"
			onClick={action}
		>
			{/* Label */}
			<Text className={classes.optionLabel}>
				{text}
			</Text>
			{/* Checkbox */}
			<Checkbox
				radius="xl"
				size="xs"
				style={{ cursor: 'pointer' }}
				checked={active}
			/>
		</Group>
	);

}

// Main option (all)
const MainOption = ({ checked, selected, setChecked }) => {

	// State and hooks
	const { classes, cx } = useStyles();

	// Trigger selection of all elements
	const triggerAll = () => {

		// If all are not selected, do nothing
		if (selected[0].length === 0) return;

		// De-select all elements
		selected[1]([]);

		// Check "all"
		setChecked(true);

	}

	return (
		<Group
			className={cx(classes.optionRow, { [classes.isSelected]: checked })}
			position="apart"
			onClick={triggerAll}
		>
			{/* Label */}
			<Text
				className={classes.optionLabel}
				fw="bold"
			>
				Todos
			</Text>
			{/* Checkbox */}
			<Checkbox
				size="xs"
				style={{ cursor: 'pointer' }}
				checked={checked}
				onChange={() => {}}
			/>
		</Group>
	);

}

const PostGeneralSelector = ({ options, selected, orderByDate, dateOrder, resetFilters }) => {

	// State and hooks
	const [opened, setOpened] = useState(false);
	const { classes, cx } = useStyles();
	const [checked, setChecked] = useState(true);

	// Listen for changes
	useEffect(() => {

		// If one is checked, disable "all"
		if (selected && selected[0].length !== 0) setChecked(false);

		// If all are unchecked, enable "all"
		if (selected && selected[0].length === 0) setChecked(true);

	}, [selected]);

	// Each category option
	const eachCategoryOption = (val, i) => {

		return (
			<Group
				className={cx(classes.optionRow, { [classes.isSelected]: selected[0].includes(val) })}
				key={i}
				position="apart"
				onClick={() => selected[1](els => els.includes(val) ? els.filter(item => item !== val) : [...els, val])}
			>
				{/* Label */}
				<Text className={classes.optionLabel}>
					{val}
				</Text>
				{/* Checkbox */}
				<Checkbox
					size="xs"
					style={{ cursor: 'pointer' }}
					checked={selected[0].includes(val)}
				/>
			</Group>
		);

	}
	
	return (
		<Popover
			opened={opened}
			onChange={setOpened}
			shadow="md"
			width={230}
			position="bottom-end"
			withArrow
			offset={3}
			arrowOffset={10}
		>
			{/* Opener */}
			<Popover.Target>
				{/* Purple Circle */}
				<Indicator
					offset={6}
					size={14}
					withBorder
					disabled
				>
					{/* Icon */}
					<ActionIcon
						variant="white"
						onClick={() => setOpened((o) => !o)}
					>
						<IconAdjustmentsHorizontal
							stroke={1.7}
							size={22}
						/>
					</ActionIcon>
				</Indicator>
			</Popover.Target>
			{/* Content */}
			<Popover.Dropdown
				p={0}
				pb={8}
			>
				{/* Top */}
				<Group position="apart">
					{/* Label */}
					<Text className={classes.label}>
						Filtrar por
					</Text>
					{/* Reset */}
					<Anchor
						type="button"
						size="xs"
						pr={12}
						onClick={resetFilters}
					>
						Limpiar filtros
					</Anchor>
				</Group>
				<Divider />
				{/* Date */}
				<Text className={classes.label}>
					Fecha
				</Text>
				{/* Options */}
				<Option
					text="Por vencer"
					action={() => orderByDate('endDate')}
					active={dateOrder === 'endDate'}
				/>
				<Option
					text="Más reciente"
					action={() => orderByDate('startDate')}
					active={dateOrder === 'startDate'}
				/>
				{/* Category */}
				<Text className={classes.label}>
					Categoría
				</Text>
				<MainOption
					checked={checked}
					selected={selected}
					setChecked={setChecked}
				/>
				{options?.categories?.map(eachCategoryOption)}
			</Popover.Dropdown>
		</Popover>
	);

}

export default PostGeneralSelector;
